import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICategoriaDeProduto } from '../types/ICategoriaDeProduto';

@Injectable({ providedIn: 'root' })
export class ProdutoState {
  private produtos = new BehaviorSubject<ICategoriaDeProduto[] | null>(null);
  private requestingProdutos = new BehaviorSubject<boolean>(false);
  private produtoSelecionado: ICategoriaDeProduto | null = null;
  private requestingPostDownload: boolean = false;

  setProdutos(produtos: ICategoriaDeProduto[]) {
    this.produtos.next(produtos);
  }

  getProdutos() {
    return this.produtos.asObservable();
  }

  getCurrentProdutos() {
    return this.produtos.getValue();
  }

  setRequestingProdutos(isRequestingProdutos: boolean) {
    this.requestingProdutos.next(isRequestingProdutos);
  }

  isRequestingProdutos() {
    return this.requestingProdutos.asObservable();
  }

  setProdutoSelecionado(produto: ICategoriaDeProduto) {
    this.produtoSelecionado = produto;
  }

  setRequestingPostDownload(value: boolean) {
    this.requestingPostDownload = value;
  }

  isRequestingPostDownload() {
    return this.requestingPostDownload;
  }

  getProdutoSelecionado() {
    return this.produtoSelecionado;
  }

  hasProdutoSelecionado() {
    return this.produtoSelecionado !== null;
  }

  isEmpty() {
    return this.produtos.getValue() === null;
  }

  reset() {
    this.produtos.next(null);
    this.produtoSelecionado = null;
    this.requestingProdutos.next(false);
    this.requestingPostDownload = false;
  }
}